import type { ErrorType } from '~/data/ErrorRecord';
import type { UserInviteFields } from './UserInvite';

export const defaultState: InvitesListFields = {
  isLoading: false,
  invites: [],
  error: undefined,
};

export interface InvitesListFields {
  isLoading: boolean;
  invites: UserInviteFields[];
  error?: ErrorType;
}
